import { http } from '@/shared/api/http';
import type {
  AddExecutionStepRequest,
  ExecutionFile,
  ExecutionFileStatus,
  ExecutionStep,
} from '@/shared/types/domain';

export interface ListExecutionFilesQuery {
  branchId?: number;
  departmentId?: number;
  /** PR-12 (customer feedback E-2 / Q-A): "region" filter — region = court. */
  courtId?: number;
  status?: ExecutionFileStatus;
  year?: number;
  /**
   * Customer feedback round-3 — the default "ملفات التنفيذ" tab sets this so
   * CLOSED files don't appear there; they live only in "الملفات المنفّذة".
   */
  excludeClosed?: boolean;
  page?: number;
  size?: number;
}

export async function listExecutionFiles(q: ListExecutionFilesQuery): Promise<ExecutionFile[]> {
  const r = await http.get<ExecutionFile[]>('/execution-files', { params: q });
  return r.data;
}

export async function getExecutionFile(id: number): Promise<ExecutionFile> {
  const r = await http.get<ExecutionFile>(`/execution-files/${id}`);
  return r.data;
}

export async function listExecutionSteps(id: number): Promise<ExecutionStep[]> {
  const r = await http.get<ExecutionStep[]>(`/execution-files/${id}/steps`);
  return r.data;
}

export async function addExecutionStep(
  id: number, body: AddExecutionStepRequest,
): Promise<ExecutionStep> {
  const r = await http.post<ExecutionStep>(`/execution-files/${id}/steps`, body);
  return r.data;
}

